<div class="drawer-layout">
  @if (!openedMessage) {
    <div class="drawer-content flex-row justify-content-space-between align-items-center">
      <button mat-button
              class="drawer-action-button"
              (click)="onSendNewMessageClick()"
      >
        <mat-icon>add</mat-icon> <span class="button-label">Send new message...</span>
      </button>

      <app-filter-button [appliedFiltersCount]="appliedFiltersCount"
                         [active]="showingFilterBar"
                         (toggled)="toggleFilter()"
      ></app-filter-button>
    </div>

    @if (configuration) {
      <div class="drawer-action-form"
           [ngClass]="{'show-form': showNewMessageForm}"
      >
        <div class="form-line">
          <div class="form-icon">
            <mat-icon>person_add</mat-icon>
          </div>

          <mat-form-field class="w-100" color="accent" appearance="outline">
            <mat-label>Recipients</mat-label>
            <mat-chip-grid #chipGrid aria-label="Recipients selection" required>
              @for (recipient of formData.recipients; track $index) {
                <mat-chip-row
                  [editable]="selectable"
                  [removable]="removable"
                  (removed)="remove(recipient)"
                >
                  <div class="recipient-chip">
                    <mat-icon>{{ getIconName(recipient.type) }}</mat-icon>
                    <span class="recipient-chip-label">{{ recipient.name }}</span>
                  </div>
                  @if (removable) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip-row>
              }
              <input
                placeholder="{{ getRecipientsPlaceholder() }}"
                #recipientInput
                [formControl]="recipientsForm"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipGrid"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              />
            </mat-chip-grid>
            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="selected($event.option.value)"
            >
              @for (recipientType of filteredRecipients | async; track $index) {
                <mat-optgroup
                  [label]="recipientType.type"
                >
                  @for (recipient of recipientType.recipients; track $index) {
                    <mat-option
                      [value]="recipient"
                    >
                      <span class="select-recipient-option">{{ recipient.name }}</span>
                    </mat-option>
                  }
                </mat-optgroup>

              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="form-line">
          <div class="form-icon">
            <mat-icon>subheader</mat-icon>
          </div>

          <mat-form-field class="w-100" color="accent" appearance="outline">
            <mat-label>Subject</mat-label>
            <input
              matInput
              autocomplete="off"
              [(ngModel)]="formData.subject"
              placeholder="Your message subject..."
              #ngSubject="ngModel"
              minlength="2"
              maxlength="500"

            />
          </mat-form-field>
        </div>
        <div class="form-line">
          <div class="form-icon justify-content-space-between flex-column">
            <mat-icon>message</mat-icon>
            <div style="    margin-left: -10px; margin-bottom: 20px;">
              <button mat-icon-button
                      [matTooltip]="'Copy from template'"
                      [matMenuTriggerFor]="templatesMenu"
              >
                <mat-icon>chat_paste_go</mat-icon>
              </button>
              <mat-menu #templatesMenu="matMenu">
                @if (templates.length === 0) {
                  <div class="m-15">No templates. Hint: Create one by below button.</div>
                }
                @for (template of templates; track $index) {
                  <button mat-menu-item
                          (click)="copyTemplateToMessage(template)"
                  >
                    {{ template.title }}
                  </button>
                }
              </mat-menu>
              <button mat-icon-button
                      [matTooltip]="'Manage templates'"
                      (click)="manageTemplates()"
              >
                <mat-icon>settings</mat-icon>
              </button>
            </div>
          </div>
          <mat-form-field class="w-100" color="accent" appearance="outline">
            <mat-label>Message</mat-label>
            <textarea
              matInput
              autocomplete="off"
              rows="15"
              placeholder="Your message text..."
              [(ngModel)]="formData.body"
              #ngBody="ngModel"
              minlength="2"
              maxlength="2000"

            ></textarea>
          </mat-form-field>
        </div>

        <div class="action__row">
          <button
            color="accent"
            mat-button
            (click)="sendMessage()"
            [disabled]="ngSubject.invalid || ngBody.invalid || !formData.recipients.length"
          >
            Send
          </button>
        </div>

        @if (isSending) {
          <mat-spinner></mat-spinner>
        }
      </div>
    }

    <div>
      <app-filter-bar
        [origin]="'messages'"
        [showingFilterBar]="showingFilterBar"
        [useDateFilter]="true"
        [useStormTimeFilter]="true"
        [defaultDateFilter]="TimeRangeFilter.PAST_90_DAYS"
        (dateFilterChanged)="onDateFilterChanged($event)"
        [useDriverFilter]="true"
        (driverFilterChanged)="onDriverFilterChanged($event)"
        [useUserFilter]="true"
        (userFilterChanged)="onAuthorFilterChanged($event)"
        (appliedFiltersChanged)="appliedFiltersCount = $event"
      >
      </app-filter-bar>
    </div>

    <div class="drawer-content">
      @for (item of items; track $index) {
        <div class="cards-container">
          <app-card-menu-item
            [item]="item"
          ></app-card-menu-item>
        </div>
      }
    </div>
  } @else {
    <div class="drawer-content">
      <app-message [message]="openedMessage"
                   (messageClosed)="onMessageClosed()"
                   (messageDeleted)="onMessageDeleted($event)"
      ></app-message>
    </div>
  }
</div>
